module.exports = __webpack_public_path__ + "images/renters.325d0d620b8a7194c19cf1d4a18f9814.svg";